<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :is-row-selectable="isRowSelectable"
        row-selection="single"
        :auto-select-first-row="false"
        :rows="rows"
        class="agGrid"
        :auto-size-cell="true"
        @refresh="onRefresh"
      />
    </div>

    <div class="button-containers">
      <button class="btn primary small outline" @click="deleteBusinessShift">
        {{ $t('button.delete') }}
      </button>
      <button class="btn primary small" @click="updateView">
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>

    <el-dialog
      :title="!isEdit ? 'Thêm ca' : 'Sửa ca'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Khu kinh doanh</div>
                  <validation-provider rules="required" name="Khu kinh doanh">
                    <div class="child-w-80">
                      <select v-model="form.business_district_id">
                        <option
                          v-for="businessDistrict in businessDistrictList"
                          :key="businessDistrict.id"
                          :value="businessDistrict.id"
                          :label="businessDistrict.name"
                        ></option>
                      </select>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Giờ bắt đầu</div>
                  <validation-provider rules="required" name="Giờ bắt đầu">
                    <div class="child-w-80">
                      <el-time-picker
                        v-model="form.start_hour"
                        format="HH:mm"
                        value-format="HH:mm"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên ca tiếng Việt</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Tên ca tiếng Việt"
                  >
                    <div class="child-w-80">
                      <input v-model="form.name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Giờ kết thúc</div>
                  <validation-provider rules="required" name="Giờ kết thúc">
                    <div class="child-w-80">
                      <el-time-picker
                        v-model="form.end_hour"
                        format="HH:mm"
                        value-format="HH:mm"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên ca tiếng Anh</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Tên ca tiếng Anh"
                  >
                    <div class="child-w-80">
                      <input v-model="form.eng_name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider rules="required|max:255" name="Mô tả">
                    <div class="child-w-80">
                      <textarea
                        v-model="form.description"
                        style="width: 100%"
                        rows="4"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn outline small" @click="dialogFormVisible = false">
            Hủy
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateBusinessShift"
          >
            Cập nhật
          </button>
          <button v-else class="btn primary small" @click="addBusinessShift">
            Tạo mới
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders.js'
// import RightPanel from '@/components/RightPanel'
// import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
// import { getListTaxApi } from '@/api/configuration/accounting/tax.js'
// import { getListChargeServiceApi } from '@/api/configuration/accounting/chargeService.js'
// import { getBusinessTypeApi } from '@/api/common/code_base'

import bus from '@/utils/bus'
import { getListBusinessAreaApi } from '@/api/businessArea/businessArea'
import {
  addBusinessShiftApi,
  deleteBusinessShiftApi,
  getBusinessShiftByIdApi,
  getListBusinessShiftApi,
  updateBusinessShiftApi
} from '@/api/businessArea/businessShift'
import { forEach } from 'jszip/lib/object'
export default {
  components: {
    // CellRenderCheckboxReadonly,
    // // SelectWithSearchTable,
    Breadcrumb
    // RightPanel
  },
  data() {
    return {
      loading: false,
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      businessDistrictList: [],
      form: {
        name: '',
        eng_name: '',
        start_hour: '',
        end_hour: '',
        description: '',
        business_district_id: 0
      },
      defaultForm: {
        name: '',
        eng_name: '',
        start_hour: '',
        end_hour: '',
        description: '',
        business_district_id: 0
      },
      isRowSelectable: node => !node.data.isFullWidthRow,

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },

        {
          headerName: 'Mã ca',
          field: 'id',
          // cellClass: "grid-cell-centered",
          width: 50,
          sortable: false
        },
        {
          headerName: 'Tên ca tiếng Việt',
          width: 120,
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Tên ca tiếng Anh',
          field: 'eng_name',
          width: 120,
          //   maxWidth: 150,
          //   minWidth: 120,
          sortable: false
          //   cellRenderer: 'CellRenderCheckboxReadonly'
          //   cellRendererParams: (params) => {
          //     return {
          //       color: params.data.color,
          //     };
          //   },
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Giờ bắt đầu',
          field: 'start_hour',
          width: 100,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Giờ kết thúc',
          width: 100,
          field: 'end_hour',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBuildingInfo()
    }
  },
  created() {
    this.getBusinessDistrict()
    // this.getTaxList()
    // this.getFeeList()
    // this.getBusinessType()
  },

  mounted() {
    this.attachData()
  },

  methods: {
    async getBusinessDistrict() {
      let data = await getListBusinessAreaApi()
      this.businessDistrictList = data.data
    },

    onRefresh(data) {
      let params = {
        order_by: data.orderBy,
        order_tp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },

    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getListBusinessShiftApi()
      this.loading = false
      this.rows = []
      data.data?.forEach(businessDistrict => {
        this.rows = [
          ...this.rows,
          {
            name: businessDistrict?.business_district_name,
            isFullWidthRow: true
          },
          ...businessDistrict?.shifts_list
        ]
      })
      // bus.$emit('endLoader')
      // this.rows = data.data
    },
    async addBusinessShift() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addBusinessShiftApi(this.form)
      this.dialogFormVisible = false
      this.$message({
        type: 'success',
        message: 'Bạn đã thêm ca thành công'
      })
      this.attachData()
    },

    async updateBusinessShift() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateBusinessShiftApi(this.form)
      this.dialogFormVisible = false
      this.$message({
        type: 'success',
        message: 'Bạn đã cập nhật ca thành công'
      })
      this.attachData()
    },

    async deleteBusinessShift() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn ca!')
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá ca này?', () => {
          deleteBusinessShiftApi({
            id_list: id_list
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Bạn đã xoá ca thành công'
              })
              this.attachData()
            })
            .catch(() => {
              this.dialogFormVisible = false
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    async updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 ca để sửa')
      } else {
        // const rowData = rowsSelected[0];
        this.isEdit = true
        let data = await getBusinessShiftByIdApi(rowsSelected[0].id)
        this.form = { ...data.data }
        // this.buildingItem.building_no = rowData.building_no;
        // this.buildingItem.name = rowData.name;
        // this.buildingItem.id = rowData.id;
        // this.buildingItem.color = rowData.color;
        this.dialogFormVisible = true
      }
    },
    resetBuildingInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
